import { render } from "./rectangleIcon.vue?vue&type=template&id=6e58ad26"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/rectangleIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e58ad26"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e58ad26', __exports__)) {
    api.reload('6e58ad26', __exports__)
  }
  
  module.hot.accept("./rectangleIcon.vue?vue&type=template&id=6e58ad26", () => {
    api.rerender('6e58ad26', render)
  })

}


export default __exports__